import { takeEvery, delay, put } from 'redux-saga/effects';
import * as T from './loyaltyToastTypes';
import { removeToast } from './loyaltyToastActions';

function* removeToastAfterDelaySaga(action: { type: typeof T.REMOVE_TOAST_AFTER_DELAY; payload: string }) {
  yield delay(3000);
  yield put(removeToast(action.payload));
}

export default function* loyaltyToastSaga() {
  yield takeEvery(T.REMOVE_TOAST_AFTER_DELAY, removeToastAfterDelaySaga);
}
